module.exports = __webpack_public_path__ + "static/media/payment-gateways-icon.6bbfe7d4.svg";